import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import {
  getVisibilitySelector,
  makeAnimationOptionsSelector,
  makeModuleTypeSelector,
  TargetSelector
} from "@client/selectors";
import { type AppState, type EntityRef, type WithClassName } from "@client/types";
import { type Booleanish } from "@common/declarations";
import classNames from "classnames";
import Component, { type MapProps } from "./component";
import { makeStyleSelector } from "./selectors";

export type ContainerProps = EntityRef &
  Partial<WithClassName> & {
    children?: any;
    draggable?: Booleanish;
    style?: React.CSSProperties;
    viewonly?: boolean;
  };
export type ExlcudeSettings = "margin" | "padding";
export const makeContainer = (exlcudeSettings?: ExlcudeSettings[]) => {
  const makeMapStateToProps = () => {
    const animationOptionsSelector = makeAnimationOptionsSelector(TargetSelector.Entity);
    const visibliltySelector = getVisibilitySelector(TargetSelector.Entity);
    const moduleTypeSelector = makeModuleTypeSelector();
    const styleSelector = makeStyleSelector(TargetSelector.Entity);

    return (state: AppState, props: ContainerProps): MapProps & WithIsVisibleHOCProps => {
      const visibility = visibliltySelector(state, props);
      return {
        ...props,
        animationOptions: animationOptionsSelector(state, props),
        className: classNames(props.className, {
          faded: !visibility && state.isEditMode
        }),
        isVisible: visibility.isVisible,
        moduleType: moduleTypeSelector(state, props),
        style: styleSelector(state, { ...props, exlcudeSettings })
      };
    };
  };

  return connectCustom(makeMapStateToProps)(Component);
};
const Container = makeContainer();
export default Container;
